import * as React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { TriangleAlert } from 'lucide-react';
import { Text } from 'components/ui';

/** The check never tells us which fields were wrong, so this blames none. */
export const DETAILS_MISMATCH_MESSAGE =
  "A few details didn't match your insurer's records. Please re-check the " +
  'form and make sure they are entered exactly as they appear on your ' +
  'insurance card, then try again.';

/**
 * The limit is 5 checks per 5 minutes, so waiting clears it. The error screen's
 * own support block already carries the email and phone number.
 */
export const RATE_LIMIT_HEADING = "We're unable to verify your eligibility";
export const RATE_LIMIT_MESSAGE = 'Please try again in a few minutes.';

type Props = {
  children: React.ReactNode;
};

export const EligibilityError = ({ children }: Props) => (
  <Flex
    alignItems={'flex-start'}
    bg={'red.100'}
    borderColor={'red.200'}
    borderWidth={'1.5px'}
    gap={'12px'}
    px={'16px'}
    py={'14px'}
    rounded={'row'}
    w={'100%'}
  >
    <Box color={'red.700'} flexShrink={0} pt={'2px'}>
      <TriangleAlert size={18} />
    </Box>

    <Text color={'red.700'} fontSize={'14px'} lineHeight={'1.55'}>
      {children}
    </Text>
  </Flex>
);
